import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { take } from 'rxjs/operators';

import { ApiError, MessageService } from '../../../core';
import { ClienteTipoCrudHttpService } from '../services';
import { IMultiSelectOption, IMultiSelectSettings, IMultiSelectTexts } from 'ngx-bootstrap-multiselect';

@Component({
    selector: 'sgt-cliente-tipo-multiselect',
    templateUrl: './cliente-tipo-multiselect.component.html',
    styleUrls: ['./cliente-tipo-multiselect.component.less']
})
export class ClienteTipoMultiselectComponent implements OnInit {
    /** Tipos de clientes selecionados */
    @Input() idsClientesTipos: number[];
    /** Ao alterar a seleção dos tipos de clientes */
    @Output() idsClientesTiposChange = new EventEmitter<number[]>();

    // Settings
    settings: IMultiSelectSettings;
    @Input() pullRight = false;
    @Input() enableSearch = true;
    @Input() showCheckAll = true;
    @Input() showUncheckAll = true;
    @Input() dynamicTitleMaxItems = 0;
    @Input() fixedTitle = false;
    /** Se deve exibir o multiselect acima */
    @Input() dropup = false;
    /** Se deve desabilitar o multiselect */
    @Input() disabled = false;

    // Texts
    texts: IMultiSelectTexts;
    @Input() checkAll = 'Selecionar Todos';
    @Input() uncheckAll = 'Limpar';
    @Input() defaultTitle = 'Nenhum Tipo';
    @Input() checked = 'Tipo';
    @Input() checkedPlural = 'Tipos';
    @Input() searchPlaceholder = 'Pesquisar...';
    @Input() allSelected = 'Todos Selecionados';
    @Input() searchEmptyResult = 'Nenhum tipo encontrado';
    @Input() searchNoRenderText = 'Digite para pesquisar';

    // Options
    options: IMultiSelectOption[];

    constructor(private messageService: MessageService,
                private clienteTipoCrudHttpService: ClienteTipoCrudHttpService) { }

    ngOnInit() {
        // Settings
        this.settings = {
            pullRight: this.pullRight,
            enableSearch: this.enableSearch,
            containerClasses: `container-multiselect container-multiselect-cliente-tipo ${this.dropup ? 'dropup' : 'dropdown'}`,
            showCheckAll: this.showCheckAll,
            showUncheckAll: this.showUncheckAll,
            dynamicTitleMaxItems: this.dynamicTitleMaxItems,
            fixedTitle: this.fixedTitle
        };
        // Texts
        this.texts = {
            checkAll: this.checkAll,
            uncheckAll: this.uncheckAll,
            defaultTitle: this.defaultTitle,
            checked: this.checked,
            checkedPlural: this.checkedPlural,
            searchPlaceholder: this.searchPlaceholder,
            allSelected: this.allSelected,
            searchEmptyResult: this.searchEmptyResult,
            searchNoRenderText: this.searchNoRenderText
        };

        this.create();
    }

    /** Cria os tipos de clientes para o multiselect */
    private create() {
        this.options = [];
        const selects: IMultiSelectOption[] = [];

        this.clienteTipoCrudHttpService.search()
            .pipe(
                take(1)
            )
            .subscribe(
                entities => {
                    // Adicionando os tipos de clientes ao multiselect
                    if (entities) {
                        entities.forEach(entity => {
                            selects.push({
                                id: entity.id,
                                name: entity.nome
                            });
                        });
                        this.options = selects;
                    }
                },
                (error: ApiError) => {
                    this.messageService.error(error.message,  'Erro ao pesquisar os tipos de clientes', error);
                }
            );
    }

    /** Ao alterar a seleção dos tipos de clientes */
    onChange() {
        this.idsClientesTiposChange.emit(this.idsClientesTipos);
    }
}
